import { aboutImage } from "@/mocks/content";

const audiences = [
  {
    icon: "ri-search-eye-line",
    title: "想先找到方向",
    text: "如果你还不确定从哪部开始，可以先看「编辑精选」与「题材选片」，按题材标签缩小范围。",
  },
  {
    icon: "ri-book-2-line",
    title: "想先了解剧情",
    text: "如果你更在意故事讲什么，可以直接跳到「剧情看点」，那里梳理了这类题材常见的叙事方式。",
  },
  {
    icon: "ri-file-list-3-line",
    title: "想确认版本与顺序",
    text: "完整版、未删减、看全集之间的差别，集中在「观看指南」里说明，方便你决定从哪一集开始。",
  },
];

export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-24 bg-background-100">
      <div className="max-w-content mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-center">
          <div className="relative order-2 lg:order-1" data-reveal>
            <div className="rounded-2xl overflow-hidden w-full h-[300px] md:h-[420px] bg-background-200">
              <img
                src={aboutImage}
                alt="安静客厅里摆放着绿植与书本的暖色插画"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute top-4 right-4 bg-background-50 border border-background-200 rounded-lg px-4 py-3">
              <p className="text-xs text-foreground-500">内容定位</p>
              <p className="mt-1 font-heading font-semibold text-foreground-950 text-sm">
                题材索引 · 说明型页面
              </p>
            </div>
          </div>

          <div className="order-1 lg:order-2" data-reveal>
            <span className="text-xs font-medium tracking-wide text-secondary-700 bg-secondary-100 px-3 py-1.5 rounded-full">
              站点导读
            </span>
            <h2 className="mt-4 font-heading font-semibold text-2xl md:text-3xl text-foreground-950 leading-snug">
              这是一页怎样的内容，适合谁来读
            </h2>
            <p className="mt-4 text-foreground-600 leading-8">
              「年轻的母亲在线」不是播放平台本身，而是一页围绕年轻母亲题材的内容索引。
              我们假设读者关心三件事：有没有值得看的方向、故事大概讲什么、以及不同版本该怎么看。
              因此页面把题材条目、剧情看点与观看方式分成独立分区，避免反复讲同一段内容。
            </p>
            <p className="mt-3 text-foreground-600 leading-8">
              需要说明的是，页面中的排行、评分与条目说明均为编辑按题材类型整理的示意内容，
              用于帮助浏览，并不代表任何平台的官方信息。实际观看时，请以对应平台提供的版本与说明为准。
            </p>

            <div className="mt-8 space-y-3">
              {audiences.map((a) => (
                <div
                  key={a.title}
                  className="flex items-start gap-4 p-4 rounded-xl bg-background-50 border border-background-200"
                >
                  <span className="w-10 h-10 shrink-0 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                    <i className={`${a.icon} text-lg`} aria-hidden="true"></i>
                  </span>
                  <div>
                    <h3 className="font-medium text-foreground-900">{a.title}</h3>
                    <p className="mt-1 text-sm text-foreground-600 leading-6">{a.text}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}